export class State {
  constructor(public id: number,
              public countryid: number,
              public cd: string,
              public name: string) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/state.ts